import { render, staticRenderFns } from "./DeletePromotion.vue?vue&type=template&id=86c40902&scoped=true&"
import script from "./DeletePromotion.vue?vue&type=script&lang=js&"
export * from "./DeletePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c40902",
  null
  
)

export default component.exports